// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/app.styl
// module id = 47
// module chunks = 0